/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { RichTextComponent, Image } from '@msdyn365-commerce/core';
import classnames from 'classnames';
import { IDobbiesMaintenanceData } from './dobbies-maintenance.data';
import { IDobbiesMaintenanceProps } from './dobbies-maintenance.props.autogenerated';

export interface IDobbiesMaintenanceViewProps extends IDobbiesMaintenanceProps<IDobbiesMaintenanceData> {
    text?: React.ReactNode;
    overlay: INodeProps;
    maintenanceBlockContainer: IModuleProps;
    logo?: React.ReactNode;
    background?: INodeProps;
}

class DobbiesMaintenance extends React.PureComponent<IDobbiesMaintenanceProps<IDobbiesMaintenanceData>> {
    public render(): JSX.Element | null {
        const { paragraph, className } = this.props.config;
        const dobbiesMaintenanceText = paragraph && <RichTextComponent text={paragraph} className='ms-dobbies-maintenance__text' />;
        if (!dobbiesMaintenanceText) {
            this.props.context.telemetry.error('Dobbies maintenance content is empty, module wont render.');
            return null;
        }
        const logo = this.props.config.logo && (
            <Image
                requestContext={this.props.context.actionContext.requestContext}
                className='ms-dobbies-maintenance__logo'
                {...this.props.config.logo}
                gridSettings={this.props.context.request.gridSettings!}
                loadFailureBehavior='hide'
                width={200}
                height={undefined}
            />
        );
        const dobbiesMaintenanceViewProps = {
            ...this.props,
            logo,
            text: dobbiesMaintenanceText,
            maintenanceBlockContainer: {
                moduleProps: this.props,
                className: classnames('ms-dobbies-maintenance', className)
            },
            overlay: {
                className: classnames('ms-dobbies-maintenance__overlay', className)
            },
            background: this.props.config.background && {
                className: classnames('ms-dobbies-maintenance__bg', className),
                style: {
                    backgroundImage: `url(${this.props.config.background.src})`
                }
            }
        };
        return this.props.renderView(dobbiesMaintenanceViewProps) as React.ReactElement;
    }
}

export default DobbiesMaintenance;
